import { Component, OnInit } from '@angular/core';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { MatSnackBar } from '@angular/material/snack-bar';

import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.scss']
})
export class UpdateProfileComponent {
  isLoading: boolean = false;
  errors: any = {};
  errorMessage: string = "";
  updateForm = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    password: ['', [Validators.required, Validators.minLength(6)]]
  });
  user_details: any;


  constructor(private fb: FormBuilder, 
    private apiService: ApiService, 
    private storage: StorageService, 
    public router: Router,
    public authService: AuthService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UpdateProfileComponent>) { }


    updateProfile() {
      if (this.updateForm.valid) {
        this.isLoading = true;
        const details = {
          'name': this.updateForm.value.name,
          'email': this.updateForm.value.email,
          'phone': this.updateForm.value.phone,
          'password': this.updateForm.value.password,
        };
        this.apiService.updateUserProfile(details).subscribe({
          next: (response: any) => {
            this.spinner.show();
            if (response.success === true) {
              // mat spinner 
              this.isLoading = false;
              this.dialogRef.close();
              
              this.snackBar.open(`${response.message}, Please login to continue...`, 'Close', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: ['green-snackbar']
              });
              this.router.navigate(['/login'])
              // this.spinner.hide
              this.spinner.hide();
            }else if (response.message === "unauthenticated") {
              this.snackBar.open(`${response.message} Please login to continue...`, 'Close', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: ['green-snackbar']
              });
              this.router.navigate(['/login'])
              this.spinner.hide();
            } else {
              this.isLoading = false;
              this.snackBar.open(response.message, 'Close', {
                duration: 0,
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
                panelClass: ['red-snackbar']
              });
              this.spinner.hide();
            }
          },
          error: (err: any) => {
            this.isLoading = false;
            this.errorMessage = err.error.message;
            setTimeout(() => {
              this.errorMessage = "";
              this.snackBar.open(this.errorMessage, 'Close', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
                panelClass: ['red-snackbar']
              });
            }, 3000);
            this.spinner.hide();
          },
          complete: () => { }
        });
      }
    }

  ngOnInit(): void {
    this.user_details = JSON.parse(this.storage.get('user_data') || '[]');
    // Updating value to the respective mat form fields
    this.updateForm.patchValue({
      name: this.user_details.data.name,
      email: this.user_details.data.email,
      phone: this.user_details.data.phone,
      password: this.user_details.data.password,
    });
  }

}
